import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * This metadata contains all information about entity's listeners.
 */
export var EntityListenerMetadata = /*#__PURE__*/function () {
  // ---------------------------------------------------------------------
  // Constructor
  // ---------------------------------------------------------------------
  function EntityListenerMetadata(options) {
    _classCallCheck(this, EntityListenerMetadata);
    this.entityMetadata = options.entityMetadata;
    this.embeddedMetadata = options.embeddedMetadata;
    this.target = options.args.target;
    this.propertyName = options.args.propertyName;
    this.type = options.args.type;
  }
  // ---------------------------------------------------------------------
  // Public Methods
  // ---------------------------------------------------------------------
  /**
   * Checks if entity listener is allowed to be executed on the given entity.
   */
  _createClass(EntityListenerMetadata, [{
    key: "isAllowed",
    value: function isAllowed(entity) {
      // todo: create in entity metadata method like isInherited?
      return this.entityMetadata.target === entity.constructor ||
      // todo: .constructor won't work for entity schemas, but there are no entity listeners in schemas since there are no objects, right?
      typeof this.entityMetadata.target === "function" && entity.constructor.prototype instanceof this.entityMetadata.target; // todo: also need to implement entity schema inheritance
    }
    /**
     * Executes listener method of the given entity.
     */
  }, {
    key: "execute",
    value: function execute(entity) {
      if (!this.embeddedMetadata) return entity[this.propertyName]();
      this.callEntityEmbeddedMethod(entity, this.embeddedMetadata.propertyPath.split("."));
    }
    // ---------------------------------------------------------------------
    // Protected Methods
    // ---------------------------------------------------------------------
    /**
     * Calls embedded entity listener method no matter how nested it is.
     */
  }, {
    key: "callEntityEmbeddedMethod",
    value: function callEntityEmbeddedMethod(entity, propertyPaths) {
      var _this = this;
      var propertyPath = propertyPaths.shift();
      if (!propertyPath || !entity[propertyPath]) return;
      if (propertyPaths.length === 0) {
        if (Array.isArray(entity[propertyPath])) {
          entity[propertyPath].map(function (embedded) {
            return embedded[_this.propertyName]();
          });
        } else {
          entity[propertyPath][this.propertyName]();
        }
      } else {
        if (entity[propertyPath]) this.callEntityEmbeddedMethod(entity[propertyPath], propertyPaths);
      }
    }
  }]);
  return EntityListenerMetadata;
}();